import { render, staticRenderFns } from "./add-position.vue?vue&type=template&id=84d8638e&scoped=true"
import script from "./add-position.vue?vue&type=script&lang=js"
export * from "./add-position.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d8638e",
  null
  
)

export default component.exports